export const Elevation = {
    50: '0px 2px 12px 4px rgba(0, 0, 0, 0.03)',
    100: '0px 2px 24px 10px rgba(0, 0, 0, 0.03)',
    200: '0px 4px 12px 0px rgba(0, 0, 0, 0.16)',
    300: '0px 8px 16px 0px rgba(0, 0, 0, 0.12)',
    400: '0px 8px 32px 0px rgba(0, 0, 0, 0.16)',
};
